import { useSourceEntitiesByName } from '@hakimo-ui/hakimo/data-access';
import { SourceEntityNameFilterValue } from '@hakimo-ui/hakimo/types';
import { currentTenantAtom } from '@hakimo-ui/hakimo/util';
import { useAtomValue } from 'jotai';
import MultiSelectFilter from '../multi-select-filter/MultiSelectFilter';

interface Props {
  value: SourceEntityNameFilterValue;
  label: string;
  enableNegativeFilters?: boolean;
  onChange: (value: SourceEntityNameFilterValue) => void;
}

export function SourceEntityFilter(props: Props) {
  const { value, label, enableNegativeFilters = false, onChange } = props;
  const getSourceEntitiesByName = useSourceEntitiesByName();
  const currentTenant = useAtomValue(currentTenantAtom);

  return (
    <MultiSelectFilter
      value={value}
      label={label}
      enableNegativeFilters={enableNegativeFilters}
      onChange={onChange}
      getOptions={(name: string) =>
        getSourceEntitiesByName(name, currentTenant?.id ?? '')
      }
    />
  );
}

export default SourceEntityFilter;
